
class LogoUtils {
  static async convertLogoToInline() {
    let existingSvg = document.querySelector('.header__logo svg, .header__heading svg, #Scritta, .logo svg');
    if (existingSvg) {
      return Promise.resolve();
    }

    const logoSelectors = [
      '.header__logo img',
      '.header__heading img', 
      '.logo img',
      '.header__heading-link img',
      'h1 img[alt*="logo" i]',
      'a[href="/"] img',
      'img[alt*="logo" i]'
    ];

    let logoImg = null;
    for (const selector of logoSelectors) {
      logoImg = document.querySelector(selector);
      if (logoImg) break;
    }

    if (!logoImg) {
      return Promise.reject('No logo found');
    }


    if (!logoImg.src.toLowerCase().includes('.svg')) {
      return Promise.reject('Logo is not SVG');
    }

    try {
      const response = await fetch(logoImg.src);
      const svgText = await response.text();
      
      const parser = new DOMParser();
      const svgDoc = parser.parseFromString(svgText, 'image/svg+xml');
      const svgElement = svgDoc.documentElement;

      if (svgElement.nodeName !== 'svg') {
        throw new Error('Invalid SVG content');
      }

      const computedStyle = window.getComputedStyle(logoImg);
      
      if (logoImg.width) svgElement.setAttribute('width', logoImg.width);
      if (logoImg.height) svgElement.setAttribute('height', logoImg.height);
      
      if (logoImg.className) svgElement.setAttribute('class', logoImg.className);
      if (logoImg.alt) svgElement.setAttribute('aria-label', logoImg.alt);
      
      svgElement.style.maxWidth = computedStyle.maxWidth;
      svgElement.style.maxHeight = computedStyle.maxHeight;
      svgElement.style.width = computedStyle.width;
      svgElement.style.height = computedStyle.height;

      if (!svgElement.id && logoImg.id) {
        svgElement.id = logoImg.id;
      } else if (!svgElement.id) {
        svgElement.id = 'Logo';
      }

      logoImg.parentNode.replaceChild(svgElement, logoImg);
      
      return Promise.resolve();
      
    } catch (error) {
      return Promise.reject(error);
    }
  }

  static createRainbowGradient(startColor = '#15008b') {
    const svgNS = 'http://www.w3.org/2000/svg';
    const gradientSvg = document.createElementNS(svgNS, 'svg');
    gradientSvg.setAttribute('class', 'moving-rainbow-gradient-svg');

    const defs = document.createElementNS(svgNS, 'defs');
    const gradient = document.createElementNS(svgNS, 'linearGradient');
    gradient.setAttribute('id', 'movingRainbowGradient');
    gradient.setAttribute('x1', '-200');
    gradient.setAttribute('y1', '0');
    gradient.setAttribute('x2', '0');
    gradient.setAttribute('y2', '0');
    gradient.setAttribute('gradientUnits', 'userSpaceOnUse');

    const colors = [startColor, '#ff0000', '#ff8000', '#ffff00', '#00ff00', '#8000ff', startColor];
    colors.forEach((color, index) => {
      const stop = document.createElementNS(svgNS, 'stop');
      stop.setAttribute('offset', `${(index / (colors.length - 1)) * 100}%`);
      stop.setAttribute('stop-color', color);
      gradient.appendChild(stop);
    });

    defs.appendChild(gradient);
    gradientSvg.appendChild(defs);
    document.body.appendChild(gradientSvg);

    return gradient;
  }

  static animateRainbowGradient(logo) {
    const gradient = document.getElementById('movingRainbowGradient');
    if (!gradient || !logo) return null;

    const bbox = logo.getBBox();
    const gradientWidth = bbox.width * 2;
    let position = -bbox.width;

    let animationId = null;
    const state = {
      running: false,
      start() {
        if (state.running) return;
        state.running = true;
        tick();
      },
      stop() {
        if (!state.running) return;
        state.running = false;
        if (animationId) {
          cancelAnimationFrame(animationId);
        }
      }
    };

    const tick = () => {
      if (!state.running) return;
      position += 2;
      if (position > bbox.width) position = -gradientWidth;

      gradient.setAttribute('x1', position);
      gradient.setAttribute('x2', position + gradientWidth);
      gradient.setAttribute('y1', bbox.y);
      gradient.setAttribute('y2', bbox.y);

      animationId = requestAnimationFrame(tick);
    };

    state.start();
    return state;
  }
}

window.LogoUtils = LogoUtils;
